
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Project from "../pages/project/page";
import Donate from "../pages/donate/page";
import Apply from "../pages/apply/page";
import Transparency from "../pages/transparency/page";
import Volunteer from "../pages/volunteer/page";
import VolunteerApply from "../pages/volunteer/apply/page";
import About from "../pages/about/page";
import Partners from "../pages/partners/page";
import Shop from "../pages/shop/page";
import StoryDetail from "../pages/story/page";
import MediaDetail from "../pages/media/page";
import DropsDynamicsPage from "../pages/drops-dynamics/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/project",
    element: <Project />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "/apply",
    element: <Apply />,
  },
  {
    path: "/transparency",
    element: <Transparency />,
  },
  {
    path: "/volunteer",
    element: <Volunteer />,
  },
  {
    path: "/volunteer/apply",
    element: <VolunteerApply />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/partners",
    element: <Partners />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/drops-dynamics",
    element: <DropsDynamicsPage />,
  },
  {
    path: "/story/:id",
    element: <StoryDetail />,
  },
  {
    path: "/media/:id",
    element: <MediaDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
